document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('.menu-toggle');
  const menu = document.querySelector('#PrimaryNavigation');
  if (menuButton && menu) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!open));
      menu.classList.toggle('is-open', !open);
    });
  }

  document.querySelectorAll('[data-booking-calendar]').forEach(setupBookingCalendar);
  document.querySelectorAll('.booking-manage').forEach(setupManageForm);

  document.querySelectorAll('[data-arrival-slider]').forEach(setupArrivalSlider);
  document.querySelectorAll('[data-product-slider]').forEach(setupProductSlider);
  document.querySelectorAll('[data-product-form-wrap]').forEach(setupProductForm);

  document.querySelectorAll('[data-size-chart-open]').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const modal = document.getElementById(trigger.dataset.sizeChartOpen);
      if (modal && modal.showModal) modal.showModal();
    });
  });
  document.querySelectorAll('[data-size-chart-close]').forEach(closeButton => {
    closeButton.addEventListener('click', () => {
      const modal = closeButton.closest('dialog');
      if (modal) modal.close();
    });
  });
});

function setupProductForm(root) {
  const variantsScript = root.querySelector('[data-product-variants]');
  if (!variantsScript) return;

  let variants;
  try {
    variants = JSON.parse(variantsScript.textContent);
  } catch (e) {
    return;
  }

  const idInput = root.querySelector('[data-selected-variant-id]');
  const priceEl = root.querySelector('[data-product-price]');
  const saleBadge = root.querySelector('[data-sale-badge]');
  const submitButton = root.querySelector('[data-add-to-cart]');
  const submitText = root.querySelector('[data-add-to-cart-text]');
  const skuEl = root.querySelector('[data-product-sku]');
  const lowStockEl = root.querySelector('[data-product-low-stock]');
  // Low stock texts per quantity (1..threshold), already pluralized and translated by Liquid.
  let lowStockTexts = {};
  try {
    lowStockTexts = JSON.parse((lowStockEl && lowStockEl.dataset.lowStockTexts) || '{}');
  } catch (e) {
    lowStockTexts = {};
  }
  const noteEl = root.querySelector('[data-variant-note]');
  const optionGroups = Array.from(root.querySelectorAll('.product-option'));
  const optionIndexes = optionGroups.map(group => Number(group.dataset.optionIndex));
  const colorGroup = root.querySelector('.product-option[data-color-option]');
  const colorIndex = colorGroup ? Number(colorGroup.dataset.optionIndex) : -1;
  const section = root.closest('[data-product-section]');
  const gallery = section ? section.querySelector('[data-product-gallery]') : null;
  const mediaItems = gallery ? Array.from(gallery.querySelectorAll('[data-media-id]')) : [];
  const assignedMedia = new Set(variants.map(variant => variant.featured_media_id).filter(Boolean));
  const selected = [];

  optionGroups.forEach(group => {
    const index = Number(group.dataset.optionIndex);
    const activeButton = group.querySelector('.is-selected');
    const activeSelect = group.querySelector('select.option-dropdown');
    if (activeButton) selected[index] = activeButton.dataset.optionValue;
    else if (activeSelect) selected[index] = activeSelect.value;
  });

  const findVariant = () => variants.find(variant => variant.options.every((value, index) => value === selected[index]));

  const variantExists = (index, value, fixedIndexes) => variants.some(variant =>
    variant.options[index] === value && fixedIndexes.every(other => variant.options[other] === selected[other]));

  // The first option stays clickable so no existing variant becomes unreachable; later options are locked to what exists.
  const refreshOptions = () => {
    optionGroups.forEach(group => {
      const index = Number(group.dataset.optionIndex);
      const earlier = optionIndexes.filter(other => other < index);
      const others = optionIndexes.filter(other => other !== index);
      group.querySelectorAll('[data-option-value]').forEach(button => {
        const value = button.dataset.optionValue;
        button.disabled = !variantExists(index, value, earlier);
        button.classList.toggle('is-unavailable', !variantExists(index, value, others));
      });
      group.querySelectorAll('select.option-dropdown option').forEach(option => {
        option.disabled = !variantExists(index, option.value, earlier);
      });
    });
  };

  const updateGallery = variant => {
    if (!assignedMedia.size || colorIndex < 0) return;
    const colorMedia = new Set(variants
      .filter(other => other.featured_media_id && other.options[colorIndex] === variant.options[colorIndex])
      .map(other => other.featured_media_id));
    mediaItems.forEach(item => {
      const id = Number(item.dataset.mediaId);
      item.hidden = colorMedia.size > 0 && assignedMedia.has(id) && !colorMedia.has(id);
      const image = item.querySelector('img');
      if (image && !item.hidden) image.loading = 'eager';
    });
    // Photos not tied to a variant (covers) stay first, so the slider opens the color on its own first photo.
    const firstColorItem = mediaItems.find(item => colorMedia.has(Number(item.dataset.mediaId)));
    gallery.dispatchEvent(new CustomEvent('gallery:update', { detail: { mediaId: firstColorItem ? firstColorItem.dataset.mediaId : null } }));
  };

  const updateUI = () => {
    refreshOptions();
    const variant = findVariant();

    root.classList.toggle('is-variant-missing', !variant);
    if (idInput) idInput.disabled = !variant;
    if (noteEl) {
      noteEl.hidden = Boolean(variant);
      noteEl.textContent = variant ? '' : selected.join(' / ') + ' - ' + noteEl.dataset.text;
    }

    if (!variant) {
      if (submitButton) {
        submitButton.disabled = true;
        if (submitText) submitText.textContent = submitButton.dataset.unavailableText;
      }
      if (lowStockEl) {
        lowStockEl.hidden = true;
        lowStockEl.textContent = '';
      }
      return;
    }

    if (idInput) idInput.value = variant.id;
    updateGallery(variant);

    if (priceEl) {
      if (variant.on_sale) {
        priceEl.innerHTML = '<span class="product-price-sale">' + variant.price + '</span><s class="product-price-compare">' + variant.compare_at_price + '</s>';
      } else {
        priceEl.innerHTML = '<span>' + variant.price + '</span>';
      }
      if (saleBadge) {
        priceEl.appendChild(saleBadge);
        saleBadge.hidden = !variant.on_sale;
      }
    }

    if (submitButton) {
      submitButton.disabled = !variant.available;
      if (submitText) submitText.textContent = variant.available ? submitButton.dataset.availableText : submitButton.dataset.soldOutText;
    }

    if (skuEl) skuEl.textContent = variant.sku ? 'SKU: ' + variant.sku : '';
    if (skuEl) skuEl.hidden = !variant.sku;

    if (lowStockEl) {
      const lowStockText = variant.low_stock && variant.inventory_quantity > 0 ? lowStockTexts[variant.inventory_quantity] || '' : '';
      lowStockEl.hidden = !lowStockText;
      lowStockEl.textContent = lowStockText;
    }
  };

  root.querySelectorAll('[data-option-value]').forEach(button => {
    button.addEventListener('click', () => {
      const group = button.closest('.product-option');
      const index = Number(group.dataset.optionIndex);
      selected[index] = button.dataset.optionValue;
      group.querySelectorAll('[data-option-value]').forEach(sibling => {
        const isSelected = sibling === button;
        sibling.classList.toggle('is-selected', isSelected);
        sibling.setAttribute('aria-pressed', String(isSelected));
      });
      const label = group.querySelector('[data-option-value-label]');
      if (label) label.textContent = button.dataset.optionValue;
      updateUI();
      announceVariant(group, button.dataset.optionValue);
    });
  });

  root.querySelectorAll('select.option-dropdown').forEach(select => {
    select.addEventListener('change', () => {
      const group = select.closest('.product-option');
      const index = Number(select.dataset.optionIndex);
      selected[index] = select.value;
      const label = group.querySelector('[data-option-value-label]');
      if (label) label.textContent = select.value;
      updateUI();
      announceVariant(group, select.value);
    });
  });

  function announceVariant(group, value) {
    root.dispatchEvent(new CustomEvent('aura:variant-change', {
      bubbles: true,
      detail: { optionName: group.dataset.optionName, optionValue: value, variant: findVariant() || null, selected: selected.slice() }
    }));
  }

  refreshOptions();
  const initialVariant = findVariant();
  if (initialVariant) updateGallery(initialVariant);
}

function setupProductSlider(root) {
  const viewport = root.querySelector('[data-slider-viewport]');
  const dotsWrap = root.querySelector('[data-slider-dots]');
  const gallery = root.closest('[data-product-gallery]') || root;
  if (!viewport) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let current = 0;
  let reported = 0;
  let method = null;
  let settleTimer;
  let freeTimer;

  const slides = () => Array.from(viewport.children).filter(slide => !slide.hidden);
  const signatureOf = list => list.map(slide => slide.dataset.mediaId).join(',');
  let signature = signatureOf(slides());

  // Photos of other colors start hidden and lazy; fetch them once the page is idle so a color switch shows them at once.
  const warmUp = () => setTimeout(() => {
    viewport.querySelectorAll('img[loading="lazy"]').forEach(image => { image.loading = 'eager'; });
  }, 1200);
  if (document.readyState === 'complete') warmUp();
  else window.addEventListener('load', warmUp, { once: true });

  const nearest = () => {
    const list = slides();
    if (viewport.scrollLeft >= viewport.scrollWidth - viewport.clientWidth - 2) return Math.max(list.length - 1, 0);
    let best = 0;
    let distance = Infinity;
    list.forEach((slide, index) => {
      const gap = Math.abs(slide.offsetLeft - viewport.scrollLeft);
      if (gap < distance) {
        distance = gap;
        best = index;
      }
    });
    return best;
  };

  const renderDots = () => {
    if (!dotsWrap) return;
    slides().forEach((slide, index) => {
      const dot = dotsWrap.querySelector(`[data-slide-dot="${slide.dataset.mediaId}"]`);
      if (!dot) return;
      dot.classList.toggle('is-active', index === current);
      if (index === current) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  };

  let pendingTarget = null;
  const goTo = (index, how) => {
    const list = slides();
    if (!list.length) return;
    const target = Math.max(0, Math.min(index, list.length - 1));
    if (Math.abs(viewport.scrollLeft - list[target].offsetLeft) < 2) return;
    method = how;
    pendingTarget = target;
    current = target;
    renderDots();
    viewport.scrollTo({ left: list[target].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
  };

  // Snap stays off while a mouse drag animates to its slide and comes back once scrolling has settled.
  const settle = () => {
    root.classList.remove('is-free');
    pendingTarget = null;
    current = nearest();
    renderDots();
    if (current !== reported) {
      reported = current;
      if (method !== 'reset') {
        root.dispatchEvent(new CustomEvent('aura:gallery-change', { bubbles: true, detail: { index: current, method: method || 'swipe' } }));
      }
    }
    method = null;
  };

  viewport.addEventListener('scroll', () => {
    const index = nearest();
    if (pendingTarget === null && index !== current) {
      current = index;
      renderDots();
    }
    clearTimeout(settleTimer);
    settleTimer = setTimeout(settle, 150);
  }, { passive: true });

  if (dotsWrap) {
    dotsWrap.addEventListener('click', event => {
      const dot = event.target.closest('[data-slide-dot]');
      if (!dot) return;
      const index = slides().findIndex(slide => slide.dataset.mediaId === dot.dataset.slideDot);
      if (index >= 0) goTo(index, 'dot');
    });
  }

  viewport.addEventListener('keydown', event => {
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
    event.preventDefault();
    goTo(current + (event.key === 'ArrowRight' ? 1 : -1), 'key');
  });

  viewport.addEventListener('dragstart', event => event.preventDefault());

  let suppressClickUntil = 0;
  const jumpTo = index => {
    const target = slides()[index];
    if (!target || Math.abs(viewport.scrollLeft - target.offsetLeft) < 2) return;
    method = 'reset';
    viewport.scrollLeft = target.offsetLeft;
  };

  const section = root.closest('[data-product-section]');
  const dialog = section ? section.querySelector('[data-lightbox]') : null;
  const lightbox = dialog && typeof dialog.showModal === 'function'
    ? setupProductLightbox(dialog, {
        visibleIds: () => slides().map(slide => slide.dataset.mediaId),
        onClose: mediaId => jumpTo(slides().findIndex(slide => slide.dataset.mediaId === mediaId))
      })
    : null;
  const openButton = root.querySelector('[data-lightbox-open]');
  if (openButton) {
    if (!lightbox) openButton.hidden = true;
    else openButton.addEventListener('click', () => {
      const slide = slides()[current];
      if (slide) lightbox.open(slide.dataset.mediaId);
    });
  }
  viewport.addEventListener('click', event => {
    if (!lightbox || Date.now() < suppressClickUntil) return;
    // With the mouse the viewport holds pointer capture for dragging, so the click lands on the viewport itself.
    const slide = event.target.closest('[data-media-id]') || slides()[current];
    if (slide && !slide.querySelector('.placeholder-svg')) lightbox.open(slide.dataset.mediaId);
  });

  viewport.addEventListener('pointerdown', event => {
    if (event.pointerType !== 'mouse' || event.button !== 0 || slides().length < 2) return;
    const startX = event.clientX;
    const startLeft = viewport.scrollLeft;
    const startIndex = current;
    let moved = false;
    clearTimeout(freeTimer);
    root.classList.add('is-dragging', 'is-free');
    viewport.setPointerCapture(event.pointerId);

    const onMove = moveEvent => {
      const delta = moveEvent.clientX - startX;
      if (Math.abs(delta) > 4) moved = true;
      viewport.scrollLeft = startLeft - delta;
    };
    const onUp = upEvent => {
      viewport.removeEventListener('pointermove', onMove);
      viewport.removeEventListener('pointerup', onUp);
      viewport.removeEventListener('pointercancel', onUp);
      root.classList.remove('is-dragging');
      if (!moved) {
        root.classList.remove('is-free');
        return;
      }
      suppressClickUntil = Date.now() + 400;
      const delta = upEvent.clientX - startX;
      const step = Math.abs(delta) > 50 ? (delta < 0 ? 1 : -1) : 0;
      goTo(startIndex + step, 'drag');
      freeTimer = setTimeout(() => root.classList.remove('is-free'), 1000);
    };
    viewport.addEventListener('pointermove', onMove);
    viewport.addEventListener('pointerup', onUp);
    viewport.addEventListener('pointercancel', onUp);
  });

  // Color changes hide or show photos; a new set of photos starts from the color's first photo (or the first one).
  gallery.addEventListener('gallery:update', event => {
    const list = slides();
    if (dotsWrap) {
      Array.from(dotsWrap.querySelectorAll('[data-slide-dot]')).forEach(dot => {
        const slide = viewport.querySelector(`[data-media-id="${dot.dataset.slideDot}"]`);
        dot.hidden = !slide || slide.hidden;
      });
      dotsWrap.hidden = list.length < 2;
    }
    root.classList.toggle('product-slider--multi', list.length > 1);
    const next = signatureOf(list);
    if (next === signature) return;
    signature = next;
    const mediaId = event.detail && event.detail.mediaId;
    const start = Math.max(0, list.findIndex(slide => slide.dataset.mediaId === mediaId));
    const left = list[start] ? list[start].offsetLeft : 0;
    current = start;
    reported = start;
    method = Math.abs(viewport.scrollLeft - left) >= 1 ? 'reset' : null;
    viewport.scrollLeft = left;
    renderDots();
  });
}

function setupProductLightbox(dialog, { visibleIds, onClose }) {
  const track = dialog.querySelector('[data-lightbox-track]');
  const counter = dialog.querySelector('[data-lightbox-counter]');
  const prevButton = dialog.querySelector('[data-lightbox-prev]');
  const nextButton = dialog.querySelector('[data-lightbox-next]');
  const closeButton = dialog.querySelector('[data-lightbox-close]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const ZOOM = 2.5;
  const MAX_ZOOM = 4;
  let index = 0;
  let reported = 0;
  let method = null;
  let settleTimer;
  let historyPushed = false;

  const slides = () => Array.from(track.children).filter(slide => !slide.hidden);
  const emit = (how, at) => dialog.dispatchEvent(new CustomEvent('aura:gallery-change', { bubbles: true, detail: { index: at, method: how } }));

  /* zoom: one frame at a time, transform = translate(x, y) scale(scale) with origin at the top-left corner */
  const zoom = { frame: null, scale: 1, x: 0, y: 0 };

  const render = animate => {
    const frame = zoom.frame;
    if (!frame) return;
    const media = frame.querySelector('img, video');
    if (animate && !reduceMotion) {
      frame.classList.add('is-animating');
      setTimeout(() => frame.classList.remove('is-animating'), 260);
    }
    const zoomed = zoom.scale > 1;
    media.style.transform = zoomed ? `translate(${zoom.x}px, ${zoom.y}px) scale(${zoom.scale})` : '';
    frame.classList.toggle('is-zoomed', zoomed);
    dialog.classList.toggle('is-zoomed', zoomed);
  };

  // Allowed translate range: the photo itself (not the letterbox around it) covers the screen; a photo narrower than the screen stays centered.
  const bounds = () => {
    const frame = zoom.frame;
    const width = frame.clientWidth;
    const height = frame.clientHeight;
    const image = frame.querySelector('img');
    const ratio = image && image.naturalWidth && image.naturalHeight ? image.naturalWidth / image.naturalHeight : width / height;
    const contentWidth = Math.min(width, height * ratio);
    const contentHeight = Math.min(height, width / ratio);
    const axis = (size, content) => {
      const offset = (size - content) / 2;
      if (zoom.scale * content <= size) {
        const centered = (size - zoom.scale * content) / 2 - zoom.scale * offset;
        return [centered, centered];
      }
      return [size - zoom.scale * (offset + content), -zoom.scale * offset];
    };
    const [minX, maxX] = axis(width, contentWidth);
    const [minY, maxY] = axis(height, contentHeight);
    return { minX, maxX, minY, maxY };
  };

  const clampPosition = () => {
    const range = bounds();
    zoom.x = Math.min(range.maxX, Math.max(range.minX, zoom.x));
    zoom.y = Math.min(range.maxY, Math.max(range.minY, zoom.y));
  };

  const resetZoom = animate => {
    if (!zoom.frame) return;
    zoom.scale = 1;
    zoom.x = 0;
    zoom.y = 0;
    render(animate);
    zoom.frame = null;
  };

  const useFrame = frame => {
    if (zoom.frame === frame) return;
    resetZoom(false);
    zoom.frame = frame;
  };

  // A bigger "sizes" makes the browser fetch a sharper file from the srcset for the zoomed photo.
  const sharpen = frame => {
    const image = frame.querySelector('img');
    if (image && image.sizes !== '300vw') image.sizes = '300vw';
  };

  const followPointer = (clientX, clientY, animate) => {
    const rect = zoom.frame.getBoundingClientRect();
    const rx = Math.min(1, Math.max(0, (clientX - rect.left) / rect.width));
    const ry = Math.min(1, Math.max(0, (clientY - rect.top) / rect.height));
    const range = bounds();
    zoom.x = range.maxX + (range.minX - range.maxX) * rx;
    zoom.y = range.maxY + (range.minY - range.maxY) * ry;
    render(animate);
  };

  const toggleZoom = (frame, clientX, clientY, pointerType) => {
    if (zoom.frame === frame && zoom.scale > 1) {
      resetZoom(true);
      return;
    }
    useFrame(frame);
    sharpen(frame);
    zoom.scale = ZOOM;
    if (pointerType === 'mouse') {
      followPointer(clientX, clientY, true);
    } else {
      const rect = frame.getBoundingClientRect();
      zoom.x = (clientX - rect.left) * (1 - ZOOM);
      zoom.y = (clientY - rect.top) * (1 - ZOOM);
      clampPosition();
      render(true);
    }
    emit('zoom', index);
  };

  const pointers = new Map();
  let gesture = null;
  const distance = (a, b) => Math.hypot(a.x - b.x, a.y - b.y);
  const midpoint = (a, b) => ({ x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 });

  track.addEventListener('dragstart', event => event.preventDefault());

  track.addEventListener('pointerdown', event => {
    const frame = event.target.closest('[data-zoom]');
    if (!frame) return;
    if (event.pointerType === 'mouse') pointers.clear();
    pointers.set(event.pointerId, { x: event.clientX, y: event.clientY, startX: event.clientX, startY: event.clientY, time: Date.now(), frame, pinch: false });
    if (pointers.size === 2) {
      const [a, b] = Array.from(pointers.values());
      a.pinch = true;
      b.pinch = true;
      useFrame(frame);
      sharpen(frame);
      const rect = frame.getBoundingClientRect();
      const mid = midpoint(a, b);
      gesture = {
        type: 'pinch',
        rect,
        startScale: zoom.scale,
        startDistance: distance(a, b) || 1,
        qx: (mid.x - rect.left - zoom.x) / zoom.scale,
        qy: (mid.y - rect.top - zoom.y) / zoom.scale
      };
      pointers.forEach((value, id) => { try { frame.setPointerCapture(id); } catch (error) {} });
    } else if (pointers.size === 1 && event.pointerType !== 'mouse' && zoom.frame === frame && zoom.scale > 1) {
      gesture = { type: 'pan', x: zoom.x, y: zoom.y, startX: event.clientX, startY: event.clientY };
      try { frame.setPointerCapture(event.pointerId); } catch (error) {}
    }
  });

  track.addEventListener('pointermove', event => {
    const pointer = pointers.get(event.pointerId);
    if (pointer) {
      pointer.x = event.clientX;
      pointer.y = event.clientY;
    }
    if (gesture && gesture.type === 'pinch' && pointers.size >= 2) {
      const [a, b] = Array.from(pointers.values());
      const mid = midpoint(a, b);
      zoom.scale = Math.max(1, Math.min(MAX_ZOOM, gesture.startScale * distance(a, b) / gesture.startDistance));
      zoom.x = mid.x - gesture.rect.left - zoom.scale * gesture.qx;
      zoom.y = mid.y - gesture.rect.top - zoom.scale * gesture.qy;
      clampPosition();
      render(false);
      return;
    }
    if (gesture && gesture.type === 'pan' && pointer) {
      zoom.x = gesture.x + (event.clientX - gesture.startX);
      zoom.y = gesture.y + (event.clientY - gesture.startY);
      clampPosition();
      render(false);
      return;
    }
    if (event.pointerType === 'mouse' && zoom.frame && zoom.scale > 1 && event.target.closest('[data-zoom]') === zoom.frame) {
      followPointer(event.clientX, event.clientY, false);
    }
  });

  const endPointer = event => {
    const pointer = pointers.get(event.pointerId);
    pointers.delete(event.pointerId);
    if (gesture && gesture.type === 'pinch') {
      if (pointers.size < 2) {
        if (zoom.scale < 1.05) resetZoom(true);
        else if (gesture.startScale <= 1) emit('zoom', index);
        gesture = null;
      }
      return;
    }
    if (gesture && gesture.type === 'pan') gesture = null;
    if (event.type !== 'pointerup' || !pointer || pointer.pinch) return;
    if (event.pointerType === 'mouse' && event.button !== 0) return;
    if (Math.hypot(event.clientX - pointer.startX, event.clientY - pointer.startY) > 8 || Date.now() - pointer.time > 500) return;
    toggleZoom(pointer.frame, event.clientX, event.clientY, event.pointerType);
  };
  track.addEventListener('pointerup', endPointer);
  track.addEventListener('pointercancel', endPointer);

  /* navigation */
  const updateChrome = () => {
    const total = slides().length;
    if (counter) counter.textContent = total > 1 ? `${index + 1} / ${total}` : '';
    if (prevButton) {
      prevButton.hidden = total < 2;
      prevButton.disabled = index <= 0;
    }
    if (nextButton) {
      nextButton.hidden = total < 2;
      nextButton.disabled = index >= total - 1;
    }
  };

  // The target becomes current at once, so quick repeated clicks keep moving forward instead of re-aiming at the same photo.
  const goTo = (target, how) => {
    const list = slides();
    if (!list.length) return;
    const clamped = Math.max(0, Math.min(target, list.length - 1));
    if (clamped === index) return;
    resetZoom(false);
    method = how;
    index = clamped;
    updateChrome();
    track.scrollTo({ left: list[clamped].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
  };

  track.addEventListener('scroll', () => {
    clearTimeout(settleTimer);
    settleTimer = setTimeout(() => {
      const list = slides();
      index = Math.max(0, Math.min(Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)), list.length - 1));
      updateChrome();
      if (zoom.frame && zoom.frame.closest('[data-lightbox-media]') !== list[index]) resetZoom(false);
      if (index !== reported) {
        reported = index;
        if (method !== 'reset') emit(method || 'lightbox_swipe', index);
      }
      method = null;
    }, 120);
  }, { passive: true });

  const showAt = position => {
    const target = slides()[position];
    if (!target) return;
    method = Math.abs(track.scrollLeft - target.offsetLeft) > 1 ? 'reset' : null;
    track.scrollLeft = target.offsetLeft;
  };

  const open = mediaId => {
    const visible = new Set(visibleIds());
    Array.from(track.children).forEach(slide => { slide.hidden = !visible.has(slide.dataset.lightboxMedia); });
    const list = slides();
    if (!list.length) return;
    const start = Math.max(0, list.findIndex(slide => slide.dataset.lightboxMedia === String(mediaId)));
    [start - 1, start, start + 1].forEach(position => {
      const image = list[position] && list[position].querySelector('img');
      if (image) image.loading = 'eager';
    });
    if (!dialog.open) {
      dialog.showModal();
      document.documentElement.classList.add('is-lightbox-open');
      if (!historyPushed) {
        history.pushState({ auraLightbox: true }, '');
        historyPushed = true;
      }
    }
    showAt(start);
    index = start;
    reported = start;
    updateChrome();
    emit('open', start);
  };

  if (prevButton) prevButton.addEventListener('click', () => goTo(index - 1, 'lightbox_arrow'));
  if (nextButton) nextButton.addEventListener('click', () => goTo(index + 1, 'lightbox_arrow'));
  if (closeButton) closeButton.addEventListener('click', () => dialog.close());

  dialog.addEventListener('keydown', event => {
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
    event.preventDefault();
    goTo(index + (event.key === 'ArrowRight' ? 1 : -1), 'lightbox_key');
  });

  // Esc first zooms out, a second Esc closes.
  dialog.addEventListener('cancel', event => {
    if (zoom.frame && zoom.scale > 1) {
      event.preventDefault();
      resetZoom(true);
    }
  });

  dialog.addEventListener('close', () => {
    resetZoom(false);
    document.documentElement.classList.remove('is-lightbox-open');
    const currentSlide = slides()[index];
    if (currentSlide && onClose) onClose(currentSlide.dataset.lightboxMedia);
    if (historyPushed) {
      historyPushed = false;
      history.back();
    }
  });

  // The phone's back button closes the gallery instead of leaving the product page.
  window.addEventListener('popstate', () => {
    if (!dialog.open) return;
    historyPushed = false;
    dialog.close();
  });

  window.addEventListener('resize', () => {
    if (!dialog.open) return;
    resetZoom(false);
    showAt(index);
  });

  return { open };
}

function setupArrivalSlider(root) {
  const slides = Array.from(root.querySelectorAll('[data-arrival-slide]'));
  const controls = Array.from(root.querySelectorAll('[data-arrival-control]'));
  const pauseButton = root.querySelector('[data-arrival-pause]');
  if (slides.length < 2) return;

  let active = 0;
  let paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let timer;
  const interval = Number(root.dataset.interval || 7000);

  const show = index => {
    active = index;
    slides.forEach((slide, slideIndex) => {
      const selected = slideIndex === active;
      slide.classList.toggle('is-active', selected);
      slide.setAttribute('aria-hidden', String(!selected));
      slide.querySelectorAll('video').forEach(video => {
        if (selected) video.play().catch(() => {});
        else video.pause();
      });
    });
    controls.forEach((control, controlIndex) => {
      const selected = controlIndex === active;
      control.classList.toggle('is-active', selected);
      if (selected) control.setAttribute('aria-current', 'true');
      else control.removeAttribute('aria-current');
    });
  };

  const start = () => {
    window.clearInterval(timer);
    if (!paused) timer = window.setInterval(() => show((active + 1) % slides.length), interval);
  };

  controls.forEach((control, index) => control.addEventListener('click', () => { show(index); start(); }));
  if (pauseButton) {
    const playText = pauseButton.dataset.playText || 'Play';
    const pauseText = pauseButton.dataset.pauseText || 'Pause';
    if (paused) pauseButton.textContent = playText;
    pauseButton.addEventListener('click', () => {
      paused = !paused;
      pauseButton.textContent = paused ? playText : pauseText;
      start();
    });
  }
  start();
}

function setupBookingCalendar(root) {
  const serviceButtons = Array.from(root.querySelectorAll('[data-service-select]'));
  const serviceOutput = root.querySelector('[data-summary-service]');
  const dateOutput = root.querySelector('[data-summary-date]');
  const dateInput = root.querySelector('[data-selected-date]');
  const continueButton = root.querySelector('[data-booking-continue]');
  const bodyField = root.querySelector('[data-booking-body]');
  const timeField = root.querySelector('[data-time-field]');
  const notesField = root.querySelector('[data-notes-field]');
  const form = root.querySelector('.booking-summary form');
  if (!serviceButtons.length) return;

  let selectedService = serviceButtons[0].dataset.serviceName || '';
  let selectedDate = null;

  const updateContinueState = () => {
    if (continueButton) continueButton.disabled = !(selectedService && selectedDate);
  };

  serviceButtons.forEach(button => {
    button.addEventListener('click', () => {
      serviceButtons.forEach(item => item.classList.remove('is-selected'));
      button.classList.add('is-selected');
      selectedService = button.dataset.serviceName || button.textContent.trim();
      if (serviceOutput) serviceOutput.textContent = selectedService;
      updateContinueState();
    });
  });

  const calendarRoot = root.querySelector('[data-calendar]');
  if (calendarRoot) {
    const monthLabel = calendarRoot.querySelector('[data-calendar-month]');
    const grid = calendarRoot.querySelector('[data-calendar-grid]');
    const prevButton = calendarRoot.querySelector('[data-calendar-prev]');
    const nextButton = calendarRoot.querySelector('[data-calendar-next]');
    const daysAhead = Number(calendarRoot.dataset.daysAhead || 30);
    const closedDays = (calendarRoot.dataset.closedDays || '').split(',').filter(Boolean).map(Number);

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const maxDate = new Date(today);
    maxDate.setDate(maxDate.getDate() + daysAhead);

    let viewYear = today.getFullYear();
    let viewMonth = today.getMonth();

    const monthFormatter = new Intl.DateTimeFormat(undefined, { month: 'long', year: 'numeric' });
    const dateFormatter = new Intl.DateTimeFormat(undefined, { weekday: 'long', month: 'long', day: 'numeric' });

    const renderMonth = () => {
      if (!grid) return;
      grid.innerHTML = '';
      const first = new Date(viewYear, viewMonth, 1);
      const startOffset = first.getDay();
      const daysInMonth = new Date(viewYear, viewMonth + 1, 0).getDate();

      for (let i = 0; i < startOffset; i++) grid.appendChild(document.createElement('span'));

      for (let day = 1; day <= daysInMonth; day++) {
        const date = new Date(viewYear, viewMonth, day);
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = String(day);

        const disabled = date < today || date > maxDate || closedDays.includes(date.getDay());
        button.disabled = disabled;
        if (disabled) button.classList.add('is-unavailable');
        if (selectedDate && date.getTime() === selectedDate.getTime()) button.classList.add('is-selected');

        if (!disabled) {
          button.addEventListener('click', () => {
            selectedDate = date;
            grid.querySelectorAll('button').forEach(item => item.classList.remove('is-selected'));
            button.classList.add('is-selected');
            if (dateInput) dateInput.value = date.toISOString().slice(0, 10);
            if (dateOutput) dateOutput.textContent = dateFormatter.format(date);
            updateContinueState();
          });
        }
        grid.appendChild(button);
      }

      if (monthLabel) monthLabel.textContent = monthFormatter.format(first);
      if (prevButton) prevButton.disabled = viewYear === today.getFullYear() && viewMonth === today.getMonth();
      if (nextButton) {
        const nextMonthFirst = new Date(viewYear, viewMonth + 1, 1);
        nextButton.disabled = nextMonthFirst > maxDate;
      }
    };

    if (prevButton) prevButton.addEventListener('click', () => {
      viewMonth -= 1;
      if (viewMonth < 0) { viewMonth = 11; viewYear -= 1; }
      renderMonth();
    });
    if (nextButton) nextButton.addEventListener('click', () => {
      viewMonth += 1;
      if (viewMonth > 11) { viewMonth = 0; viewYear += 1; }
      renderMonth();
    });

    renderMonth();
  }

  updateContinueState();

  if (form) {
    form.addEventListener('submit', () => {
      const lines = [
        'Service: ' + (selectedService || '—'),
        'Date: ' + (dateOutput ? dateOutput.textContent : '—'),
        'Preferred time: ' + (timeField && timeField.value ? timeField.value : '—')
      ];
      const notes = notesField ? notesField.value.trim() : '';
      if (notes) lines.push('', 'Notes: ' + notes);
      if (bodyField) bodyField.value = lines.join('\n');
    });
  }
}

function setupManageForm(root) {
  const form = root.querySelector('form');
  const field = root.querySelector('[data-manage-body]');
  if (!form || !field) return;
  form.addEventListener('submit', () => {
    const prefix = 'CANCELLATION / CHANGE REQUEST';
    if (!field.value.startsWith(prefix)) field.value = prefix + '\n\n' + field.value;
  });
}
